<div class="app-manager-container">
  <!-- Header -->
  <div class="app-manager-header d-none d-lg-block">
    <div class="header-content row">
      <div class="col-12 title">
        <i class="fas fa-th-large"></i>
        Our Application Manager platform, allows users to manage all their installed applications--
        perform actions such as installing, updating, uninstalling, and deactivating apps.
      </div>
    </div>
  </div>

  <!-- Stats Bar -->
  <div class="stats-bar">
    <div class="stat-card">
      <div class="stat-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
        <i class="fas fa-cubes"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Apps</div>
        <div class="stat-value">{{ allApps.length }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Installed</div>
        <div class="stat-value">{{ installedCount }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
        <i class="fas fa-download"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Available</div>
        <div class="stat-value">{{ availableCount }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
        <i class="fas fa-upload"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Upcoming</div>
        <div class="stat-value">{{ upcomingCount }}</div>
      </div>
    </div>
  </div>

  <!-- Search and Filter Bar  -->
  @if(!isLoading) {
  <div class="search-filter-bar">
    <div class="search-box">
      @if(searchQuery.length === 0) {
      <i class="fas fa-search"></i>
      } @else {
      <i class="fas fa-times" (click)="clearSearch()"></i>
      }
      <input type="text" placeholder="Search for apps..." [value]="searchQuery" (input)="onSearchChange($event)" class="search-input" />
    </div>

    <div class="filter-buttons">
      <button class="filter-btn" [class.active]="selectedFilter === 'all'" (click)="onFilterChange('all')">
        <i class="fas fa-globe"></i>
        All Apps
      </button>
      <button class="filter-btn" [class.active]="selectedFilter === 'installed'" (click)="onFilterChange('installed')">
        <i class="fas fa-check-circle"></i>
        Installed
      </button>
      <button class="filter-btn" [class.active]="selectedFilter === 'available'" (click)="onFilterChange('available')">
        <i class="fas fa-plus-circle"></i>
        Available
      </button>
      <button class="filter-btn" [class.active]="selectedFilter === 'upcoming'" (click)="onFilterChange('upcoming')">
        <i class="fas fa-upload"></i>
        Upcoming
      </button>
    </div>

    <div class="view-toggle">
      <button class="view-btn" [class.active]="!isCompactView" (click)="isCompactView = false" title="Grid View">
        <i class="fas fa-th-large"></i>
      </button>
      <button class="view-btn" [class.active]="isCompactView" (click)="isCompactView = true" title="Compact View">
        <i class="fas fa-list"></i>
      </button>
    </div>

    <button class="refresh-btn" (click)="loadApps()" [disabled]="isLoading">
      <i class="fas fa-sync-alt" [class.spinning]="isLoading"></i>
      Refresh
    </button>
  </div>
  }

  <!-- Loading Spinner -->
  @if(isLoading) {
  <div class="my-loading-spinner">
    <div class="spinner">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <p>Loading applications...</p>
  </div>
  }

  <!-- Apps Grid -->
  @if(!isLoading) {
  <div class="apps-grid" [class.compact-view]="isCompactView">
    <!-- No Results Message -->
    @if(filteredApps.length === 0) {
    <div class="no-results">
      <i class="fas fa-inbox"></i>
      <h3>No apps found</h3>
      @if(searchQuery) {
      <p>Try adjusting your search query</p>
      }
      @if(!searchQuery && selectedFilter !== 'all') {
      <p>No {{ selectedFilter }} apps available</p>
      }
    </div>
    }
    <!-- App Cards - Normal View -->
    @if(!isCompactView) {
    @for(app of filteredApps; track app._id) {
    <div class="app-card">
      <div class="app-card-header p-2" [style.background]="app.backgroundColor || '#ffffff'">
        <div class="row w-100">
          <div class="col-6">
            <img [src]="app.icon" [alt]="app.name + ' icon'" [title]="app.description || app.name || 'Application'" class="app-icon" width="48" height="48" loading="lazy" />
            @if(app.isInstalled) {
            <div class="install-badge">
              <i class="fas fa-check"></i>
            </div>
            }
          </div>
          <div class="col-6">
            @if(!app.isInstalled) {
            <button class="btn install-btn mb-1" (click)="installApp(app)" [disabled]="isLoading || app.upComing">
              <i class="fas fa-download"></i>
              Install
            </button>
            }
            @if(app.isInstalled) {
            <button class="btn uninstall-btn mb-1" (click)="uninstallApp(app)" [disabled]="isLoading">
              <i class="fas fa-trash-alt"></i>
              Uninstall
            </button>
            }
            <button class="btn open-btn mb-1" [disabled]="!app.isInstalled">
              <i class="fas fa-external-link-alt"></i>
              Open
            </button>
          </div>
        </div>
      </div>

      <div class="app-card-body">
        <h3 class="app-name" [style.color]="app.color || '#000000'">
          {{ app.name }}
        </h3>
        <p class="app-description">
          {{ app.description }}
        </p>
        <a [href]="app.url" target="_blank" class="app-url">
          <i class="fas fa-external-link-alt"></i>
          {{ app.url }}
        </a>
      </div>
    </div>
    }
    }
    <!-- App Cards - Compact View -->
    @if(isCompactView) {
    @for(app of filteredApps; track app._id) {
    <div class="app-card-compact">
      <div class="compact-icon-wrapper" [style.background]="app.backgroundColor || '#667eea'">
        <img [src]="app.icon" [alt]="app.name + ' icon'" [title]="app.description || app.name || 'Application'" class="compact-icon" width="32" height="32" loading="lazy" />
        @if(app.isInstalled) {
        <span class="compact-badge">
          <i class="fas fa-check"></i>
        </span>
        }
      </div>
      <div class="compact-info">
        <h4 class="compact-name" [style.color]="app.color || '#2d3748'">{{ app.name }}</h4>
        <p class="compact-description">{{ app.description }}</p>
      </div>
      <div class="compact-actions">
        @if(!app.isInstalled) {
        <button class="compact-btn install" (click)="installApp(app)" [disabled]="isLoading" title="Install">
          <i class="fas fa-download"></i>
        </button>
        }
        @if(app.isInstalled) {
        <button class="compact-btn uninstall" (click)="uninstallApp(app)" [disabled]="isLoading" title="Uninstall">
          <i class="fas fa-trash-alt"></i>
        </button>
        }
        <button class="compact-btn open" [disabled]="!app.isInstalled" title="Open">
          <i class="fas fa-external-link-alt"></i>
        </button>
      </div>
    </div>
    }
    }
  </div>
  }
</div>
